import { api } from "./api";

// GET /product/restriction/getStoreList
export const minMaxGetStoreListApi = () => {
  return api.get(`/product/restriction/getStoreList`);
};

// GET /product/minmax/get
export const minMaxGetApi = (params) => {
  const queryString = Object.entries(params).map(([k,v]) => `${k}=${Array.isArray(v)?v.join(","):v??""}`).join("&");
  return api.get(`/product/minmax/get?${queryString}`);
};

// POST /product/minmax/addMinAndMaxForItem
export const minMaxAddMinAndMaxForItemApi = (params) => {
  return api.post(`/product/minmax/addMinAndMaxForItem`, JSON.stringify(params));
};

// POST /product/minmax/deleteMinAndMaxForItem
export const minMaxDeleteMinAndMaxForItemApi = (params) => {
  return api.post(`/product/minmax/deleteMinAndMaxForItem`, JSON.stringify(params));
};


